import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import {Menu, X, Calculator, ChevronDown} from 'lucide-react'

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false)

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 text-blue-800 font-bold text-xl">
            <Calculator className="w-6 h-6" />
            <span>TaxPayCalculator</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-gray-700 hover:text-blue-800 transition-colors">
              Home
            </Link>
            
            {/* State Calculators Dropdown */}
            <div className="relative group">
              <button 
                className="text-gray-700 hover:text-blue-800 transition-colors flex items-center gap-1"
                onMouseEnter={() => setStateDropdownOpen(true)}
                onMouseLeave={() => setStateDropdownOpen(false)}
              >
                State Calculators
                <ChevronDown className="w-4 h-4" />
              </button>
              {stateDropdownOpen && (
                <div 
                  className="absolute top-full left-0 mt-2 w-56 bg-white shadow-lg rounded-lg py-2 border border-gray-200"
                  onMouseEnter={() => setStateDropdownOpen(true)}
                  onMouseLeave={() => setStateDropdownOpen(false)}
                >
                  <Link
                    to="/georgia-payroll-calculator"
                    className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-800 transition-colors"
                  >
                    Georgia Calculator
                  </Link>
                  <Link
                    to="/virginia-pay-calculator"
                    className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-800 transition-colors"
                  >
                    Virginia Calculator
                  </Link>
                  <Link
                    to="/california-paycheck-calculator"
                    className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-800 transition-colors"
                  >
                    California Calculator
                  </Link>
                  <Link
                    to="/washington-salary-calculator"
                    className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-800 transition-colors"
                  >
                    Washington Calculator
                  </Link>
                </div>
              )}
            </div>

            <Link to="/military-calculator" className="text-gray-700 hover:text-blue-800 transition-colors">
              Military Calculator
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <Link
              to="/"
              className="block py-2 text-gray-700 hover:text-blue-800 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <div className="py-2 text-gray-900 font-medium">State Calculators</div>
            <Link
              to="/georgia-payroll-calculator"
              className="block py-2 pl-4 text-gray-600 hover:text-blue-800 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Georgia
            </Link>
            <Link
              to="/virginia-pay-calculator"
              className="block py-2 pl-4 text-gray-600 hover:text-blue-800 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Virginia
            </Link>
            <Link
              to="/california-paycheck-calculator"
              className="block py-2 pl-4 text-gray-600 hover:text-blue-800 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              California
            </Link>
            <Link
              to="/washington-salary-calculator"
              className="block py-2 pl-4 text-gray-600 hover:text-blue-800 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Washington
            </Link>
            <Link
              to="/military-calculator"
              className="block py-2 text-gray-700 hover:text-blue-800 transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Military Calculator
            </Link>
          </div>
        )}
      </nav>
    </header>
  )
}

export default Header
